<template>
  <div>
    <AddressSearch
      :text="address.formattedAddress"
      label="Search for an address"
      use-loqate
      :class="{ 'mb-4': isDetailsVisible }"
      @place-changed="locationChange"
    />
    <p v-if="!isDetailsVisible" class="body1 content mt-2 cursor-pointer underline" @click="isDetailsVisible = true">
      Add manually
    </p>
    <HeightTransition :visible="isDetailsVisible" inner-class="flex flex-col gap-4">
      <WInput v-model="address.addressLine1" name="address_line1" label="Address line 1 (street address, P.O. box)" />

      <WInput
        v-model="address.addressLine2"
        name="address_line2"
        label="Address line 2 (apartment, suite, unit, building, floor)"
      />

      <WInput v-model="address.city" name="City" label="Town/City" />
      <WInput v-model="address.postalCode" name="postal_code" label="Post code" />
      <WInput v-model="address.state" name="state" label="County/Region" />
      <WInput v-model="address.country" name="country" label="Country" />
    </HeightTransition>
  </div>
</template>

<script setup lang="ts">
  import { ref, watch } from 'vue';
  import WInput from './Input.vue';
  import HeightTransition from './HeightTransition.vue';
  import { ILocationInfo } from 'src/utils/map';
  import AddressSearch from './AddressSearch.vue';

  const address = ref<ILocationInfo>({
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    latitude: 0,
    longitude: 0,
    formattedAddress: '',
  });

  const emit = defineEmits<{
    (e: 'place-changed', value: ILocationInfo): void;
  }>();

  const isDetailsVisible = ref(!!address.value.formattedAddress);

  function locationChange(place: ILocationInfo) {
    address.value = place;
    isDetailsVisible.value = !!place.formattedAddress;
  }

  watch(
    address,
    (val) => {
      emit('place-changed', val);
    },
    { deep: true }
  );
</script>

<style scoped></style>
